import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AbcLoginComponentInfo,
  AbcProfileSelectionComponentInfo,
  ProfileSelectionGuardService,
} from '@barthauer/abc/core/authentication';
import { KAOSProfileSelectionComponent } from '@barthauer/kaos/core/authentication';
import { CompaniesListComponent } from './core/companies/companies-list/companies-list.component';
import { CompaniesComponent } from './core/companies/companies.component';
import { CoreComponent } from './core/core.component';
import { GanttComponent } from './core/customer-space/gantt/gantt.component';
import { MeasureDetailComponent } from './core/customer-space/measure/measure-detail/measure-detail.component';
import { MeasureListComponent } from './core/customer-space/measure/measure-list/measure-list.component';
import { MeasureTaskComponent } from './core/customer-space/measure/measure-task/measure-task.component';
import { ReportsComponent } from './core/customer-space/reports/reports.component';
import { RolesComponent } from './core/customer-space/roles/roles.component';
import { StaffMembersComponent } from './core/customer-space/staff-members/staff-members.component';
import { SubProjectDetailComponent } from './core/customer-space/sub-project/sub-project-detail/sub-project-detail.component';
import { SubProjectListComponent } from './core/customer-space/sub-project/sub-project-list/sub-project-list.component';
import { TrainingCenterComponent } from './core/customer-space/training-center/training-center.component';
import { DashboardComponent } from './core/dashboard/dashboard.component';
import { HomeComponent } from './core/home/home.component';
import { LoginComponent } from './core/login/login.component';
import {  PermessionType, ROLES } from './core/models/enumeration-list.model';
import { RoleGuard } from './core/services/guards/user-role.guard';
import { DocumentComponent } from './core/shared/document/document.component';
import { UserRightComponent } from './core/user-right/user-right.component';
import { ProfileSelectionGuard } from './core/services/guards/profileSelectionGuard';
import { LandingPageComponent } from './core/shared/landing-page/landing-page.component';

const routes: Routes = [
  {
    path: AbcLoginComponentInfo.ROUTE_PATH,
    component: LoginComponent,
    data: {
      ApplicationTitle: 'UBT Arena',
      LoginIntroHtml: 'UBT Arena Login',
      MarkerTag: AbcLoginComponentInfo.ROUTE_MARKER_TAG,
      ForwardTo: AbcProfileSelectionComponentInfo.ROUTE_PATH,
    },
  },
  {
    path: AbcProfileSelectionComponentInfo.ROUTE_PATH,
    component: KAOSProfileSelectionComponent,
    canActivate: [ProfileSelectionGuard],
    data: {
      ApplicationTitle: 'KAOS arena',
      ForwardTo: 'companies',
      ForceReloadOnApply: false,
      MarkerTag: AbcProfileSelectionComponentInfo.ROUTE_MARKER_TAG,
    },
  },
  {
    path: 'landing-page',
    component: LandingPageComponent,
     
    },
  {
    path: '',
    component: CoreComponent,
    
    
    children: [
      {
        path: 'companies',
        component: CompaniesComponent,
        canActivate: [ProfileSelectionGuardService,RoleGuard ],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
         permsision: [PermessionType.SEE ]
        },
        loadChildren: () => import('./core/shared/companies/companies.module').then((module) => module.CompaniesModule),
      },
      {
        path: 'project',
        component: HomeComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: { roles: [ROLES.Admin, ROLES.CoreTeam, ROLES.SteeringCommittee],  permsision: [PermessionType.SEE ] },
      },
      {
        path: 'companiesList',
        component: CompaniesListComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: { roles: [ROLES.Admin, ROLES.CoreTeam, ROLES.SteeringCommittee] ,
            permsision: [PermessionType.SEE ]
        },
      },

      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
           permsision: [PermessionType.SEE ]
        },
      },

      {
        path: 'measures',
        component: MeasureListComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
           permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'measureDetail/:from/:id',
        component: MeasureDetailComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
             permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'documents',
        component: DocumentComponent,
        canActivate: [ProfileSelectionGuardService,RoleGuard],
        data: { roles: [ROLES.Admin, ROLES.CoreTeam, ROLES.SteeringCommittee] ,
          permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'tasks',
        component: MeasureTaskComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
         permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
         permsision: [PermessionType.SEE ]
        },
        loadChildren: () =>
          import('./core/customer-space/reports/reports.module').then((module) => module.ReportsModule),
      },
      {
        path: 'gantt',
        component: GanttComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
            permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'trainingCenter',
        component: TrainingCenterComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.MeasureManager,
            ROLES.MeasureManager,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
            ROLES.MeasureParticipant,
          ],
           permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'staffMembers',
        component: StaffMembersComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: { roles: [ROLES.Admin, ROLES.CoreTeam, ROLES.SteeringCommittee],
           permsision: [PermessionType.SEE ]
         },
      },
      {
        path: 'roles',
        component: RolesComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: { roles: [ROLES.Admin, ROLES.CoreTeam, ROLES.SteeringCommittee] ,
           permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'roleRights',
        component:UserRightComponent ,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: { roles: [ROLES.Admin] ,
             permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'subProject',
        component: SubProjectListComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
          ],
           permsision: [PermessionType.SEE ]
        },
      },
      {
        path: 'subProjectDetail/:id',
        component: SubProjectDetailComponent,
        canActivate: [ProfileSelectionGuardService, RoleGuard],
        data: {
          roles: [
            ROLES.Admin,
            ROLES.CoreTeam,
            ROLES.SteeringCommittee,
            ROLES.SubprojectDeputy,
            ROLES.SubprojectResponsible,
          ],
           permsision: [PermessionType.SEE ]
        },
      },
      {
        path: '**',
        redirectTo: 'companies',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [ProfileSelectionGuardService],
})
export class AppRoutingModule {}
